import _slicedToArray from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useRef } from 'react';
import { useInViewport } from 'ahooks';
export var LazyDetector = function LazyDetector(props) {
  var ref = useRef(null);

  var _useInViewport = useInViewport(ref),
      _useInViewport2 = _slicedToArray(_useInViewport, 1),
      inViewport = _useInViewport2[0];

  useEffect(function () {
    if (inViewport) {
      props.onActive();
    }
  }, [inViewport]);
  return React.createElement("div", {
    ref: ref
  });
};